function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B7D38D95-67E3-41C8-B599-0BAB0781B601@1x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-322.000000, -642.000000)",
  fill: "#009471"
}, /*#__PURE__*/React.createElement("g", {
  id: "Combined-Shape",
  transform: "translate(320.000000, 640.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,2 C19.1700651,2 22.1815504,3.05786037 24.6258274,4.97225938 C25.0606261,5.312801 25.1370365,5.94133846 24.7964948,6.37613709 C24.4559532,6.81093572 23.8274157,6.88734612 23.3926171,6.5468045 C21.2972521,4.90567928 18.7189914,4 16,4 C9.372583,4 4,9.372583 4,16 C4,22.627417 9.372583,28 16,28 C22.627417,28 28,22.627417 28,16 C28,15.6924947 27.9884544,15.386482 27.965485,15.0823657 C27.9238904,14.5316495 28.336615,14.0514868 28.8873312,14.0098922 C29.4380474,13.9682976 29.9182102,14.3810222 29.9598048,14.9317384 C29.9865587,15.285962 30,15.6422194 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M27.5031184,9.12400007 L27.6126983,9.22446721 C28.1795434,9.79131227 28.2506307,10.6518891 27.7987338,11.2094707 L27.7078677,11.3103209 L16.4273234,22.5908652 C15.9099471,23.1082414 15.0522802,23.1009319 14.4510497,22.5961629 L14.3414697,22.4956958 L8.52540836,16.6796344 C7.92313548,16.0773615 7.8805267,15.143493 8.43023899,14.5937808 C8.94761526,14.0764045 9.80528215,14.083714 10.4065127,14.588483 L10.5160926,14.6889501 L15.2413426,19.4145499 L25.5268447,9.12929784 C26.044221,8.61192157 26.9018879,8.61923109 27.5031184,9.12400007 Z"
}))));

var SvgCompleted = function SvgCompleted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompleted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/completed.872689a2.svg";
export { ForwardRef as ReactComponent };